/**
 * รายชื่อสาขาสำหรับ dropdown ในฟอร์ม "แจ้งย้ายสาขา"
 * ── กรอกเองแบบ Google Form (ยังไม่ได้ดึงจาก API) ──
 *
 * รูปแบบ: "<รหัส> <ชื่อสาขา>"  เช่น  "01 กาฬสินธุ์"
 * ค่าที่เลือกจะถูกส่งไป Laravel ทั้ง string — ฝั่ง Laravel แยกรหัสเอาเองได้
 * เพิ่ม/แก้สาขา: แก้ที่ list นี้แล้ว build ใหม่
 */
export const BRANCHES: string[] = [
  '00 สำนักงานใหญ่',
  '01 กาฬสินธุ์',
  '03 หนองคาย',
  '04 ศรีบุญเรือง',
  '05 นาคำไฮ',
  '06 เลิงนกทา',
  '09 โคกขมิ้น',
  '10 บ้านแท่น',
  '13 ครบุรี',
  '16 หนองเรือ',
  '18 หนองหิน',
  '19 ดอนหัน',
  '20 หนองกุง',
  '21 บ้านทุ่ม',
  '22 โพนงาม กมลาไสย',
  '23 บ้านแบก',
  '24 โพนงาม โกสุมพิสัย',
  '25 วังหินลาด',
  '26 บึงวิชัย',
  '27 เชียงเครือ',
  '28 หนองหญ้าไซ',
  '29 หนองโน',
  '30 เวียงเก่า',
  '31 บ้านเขื่อน',
  '32 โคกสี',
]
